<template>
  <v-content>
    <v-container fluid>
      <v-layout>
        <v-flex>

          <OLoadingDialog :value="isLoading"/>

          <v-card>
            <v-toolbar class="card-bar">
              <v-toolbar-title>Espelhamento SLIIC</v-toolbar-title>
              <v-btn icon class="ml-2" @click="reload">
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text class="pa-3">
              <v-row wrap class="ma-0">
                <v-col cols="4" class="cap-cont pa-3"
                  v-for="s in mongoStatsRows" :key="s[0]">
                  <label>{{s[0]}}</label>
                  <p>{{s[1]}}</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-card class="mt-3">
            <v-toolbar class="card-bar">
              <v-toolbar-title>Detalhes</v-toolbar-title>
              <v-spacer/>
              <v-text-field v-model="txtFilter" class="py-0 pl-5"
                append-icon="search"
                label="Filtro por placa..."
                single-line hide-details/>
              <v-spacer/>
            </v-toolbar>

            <ODataTable :spec="spec" :items="filteredRows"/>

          </v-card>

        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import _ from 'lodash'
import {go} from '@/models'
import OLoadingDialog from 'oderon-vue/cpts/OLoadingDialog'
import {ODataTable} from 'oderon-vue'
import {brNum} from 'oderon-commons/src/formatters'
import {matchAnyLike} from 'oderon-commons/src/utils'

const findStats = () => go('GET', `/mirrorman/stats`)

export default {
  components: { OLoadingDialog, ODataTable },
  data() {
    return {
      isLoading: false,
      txtFilter: '',
      rows: [],
      mongoStats: {},
      spec: [
        {t: 'Placa'           , d: 'vehicle'},
        {t: 'Qtde. Posições|' , d: 'count'  },
        {t: 'Min. Date|'      , d: 'minDate'},
        {t: 'Max. Date|'      , d: 'maxDate'}
      ]
    }
  },
  computed: {
    filteredRows() {
      return _.filter(this.rows,
        r => matchAnyLike(this.txtFilter, r.vehicle))
    },
    mongoStatsRows() {
      if ( this.mongoStats == null ) return []

      let {db, avgObjSize, dataSize, storageSize, objects,
        fsTotalSize, fsUsedSize} = this.mongoStats

      return [
        ['Database'   , db],
        ['ObjectCount (incl. dicionário e counters)'  , brNum(objects)],
        ['Avg. ObjSize' , brNum(Math.floor(avgObjSize)) + ' bytes'],
        ['DataSize'     , brNum(dataSize) + ' bytes'],
        ['StorageSize'  , brNum(storageSize) + ' bytes'],
        ['DiskFree'     , brNum(fsTotalSize - fsUsedSize) + ' bytes'],
      ]
    }
  },
  mounted() { this.reload() },
  methods: {
    reload() { this.$loading(() => this.fetchData()) },
    async fetchData() {
      let data = await findStats()
      this.rows = data.rows
      this.mongoStats = data.mongoStats
    }
  }
}

</script>

<style>
</style>
